import { render, staticRenderFns } from "./mbQuotation.vue?vue&type=template&id=755695aa&scoped=true&"
import script from "./mbQuotation.vue?vue&type=script&lang=js&"
export * from "./mbQuotation.vue?vue&type=script&lang=js&"
import style0 from "./mbQuotation.vue?vue&type=style&index=0&id=755695aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755695aa",
  null
  
)

export default component.exports